import React, { useContext } from "react";
import { observer } from "mobx-react";

import { MyBetsStoreContext } from "@state/context/my-bets/MyBetsStoreContext";
import { Modal } from "@lib/modal";

export default observer(function CashoutCounterModal() {
	const store = useContext(MyBetsStoreContext);

	if (store == null) {
		return null;
	}

	if (
		store.cashoutStore?.isCountdownVisible &&
		store.cashoutStore?.countdownCounter > 0
	) {
		return (
			<Modal>
				<div
					id="cardLoader"
					className="loader loader--full loader--centered"
				>
					<div className="loader--centered__countdown">
						{store.cashoutStore.countdownCounter}
					</div>
				</div>
			</Modal>
		);
	}

	if (store.cashoutStore?.isCashoutFormSubmitting) {
		return (
			<Modal>
				<div
					id="cardLoader"
					className="loader loader--full loader--centered"
				>
					<div className="loader__spinner loader__spinner--primary loader--stream__spinner" />
				</div>
			</Modal>
		);
	}

	return null;
});
